import { ErrorDialog } from "@codat/orchard-ui";
import { useProducts } from "contexts/ProductsContext";
import React, { lazy } from "react";

import ErrorBoundary from "components/ErrorBoundary/ErrorBoundary";
import Page from "components/Page";
import PageLoadingSkeleton from "components/PageLoadingSkeleton";

const RemoteSyncHealth = lazy(() => import("codat-sync-health/App"));

export const SyncHealthBanking = () => {
  const {
    productsEnabledStatus: { isBankFeedsEnabled },
  } = useProducts();

  if (!isBankFeedsEnabled) {
    return (
      <ErrorDialog
        statusCode={undefined}
        message="Sync for Banking is not enabled"
      />
    );
  }

  return (
    <Page>
      <React.Suspense fallback={<PageLoadingSkeleton />}>
        <ErrorBoundary>
          <RemoteSyncHealth />
        </ErrorBoundary>
      </React.Suspense>
    </Page>
  );
};
